import { Box, Button, Grid, InputLabel,Container, Paper, TextField, Typography } from '@mui/material'
import React, { useRef } from 'react'
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import {useSnackbar} from 'notistack'
import Navbar from '../../components/Navbar'
import {loginParent} from '../../redux/parentSlice'
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ReactCodeInput from 'react-code-input';
import Cookies from "js-cookie";
import { useState } from 'react';
const PRIMARY_COLOR = "#3B82F6FC";

export default function ParentRegister() {
    const {t} = useTranslation()
    const lang = Cookies.get("i18next") || "en";
    const {closeSnackbar,enqueueSnackbar} = useSnackbar()
    const dispatch = useDispatch()
  const inputRef = useRef();
  const [password, setPassword] = useState("");

    const { register,control, formState: { errors }, handleSubmit } = useForm({
        defaultValues: {
            email:'',
            password:'',
            name:""
        }
    });

    const navigate = useNavigate()

    async function onSubmit(data)
    {
        closeSnackbar()
        try{
            const response = await fetch(`${process.env.REACT_APP_API_KEY}api/v1/parent/signup`,{
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },     
                body:JSON.stringify({email:data.email,password:password,name:data.name})
            })
            const resData = await response.json()
            console.log(resData);
            
            if(response.status!==200&&response.status!==201)
            {
                return enqueueSnackbar(lang=="ar"? resData.message.arabic:resData.message.english,{variant:"error",autoHideDuration:"8000"})
            }
            dispatch(loginParent({parent:resData.data,token:resData.token}))
            enqueueSnackbar('success',{variant:"success",autoHideDuration:"8000"})
            navigate('/parent')
        }
        catch(err)
        {
            console.log(err);
            
            enqueueSnackbar('failed occured',{variant:"error",autoHideDuration:"8000"})
        }
    }

    return (
        <Navbar>
            <Container sx={{marginTop:"120px"}}>
                <Paper sx={{width:{md:"520px"},padding:"30px 50px",margin:"60px auto"}}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                    <Typography sx={{fontWeight: 700, fontSize: "23px", color: PRIMARY_COLOR,marginBottom:"22px",textAlign:"center"}}>{t('register parent')}</Typography>
                    <Box sx={{marginBottom:"30px"}}>
                        <InputLabel sx={{ fontWeight: 700, fontSize: "13px", color: PRIMARY_COLOR, mb: 1 }}>{t('name')}</InputLabel>
                        <Controller
                        name="name"
                        control={control}
                        render={({ field }) => <TextField type="text" {...field} fullWidth/>}
                        {...register("name", { required: "name Address is required" })}
                        />
                        {errors.name?.type === 'required' && <Typography color="error" role="alert" sx={{fontSize:"13px",marginTop:"6px"}}>this field is required</Typography>}
                    </Box>
                    <Box sx={{marginBottom:"30px"}}>
                        <InputLabel sx={{ fontWeight: 700, fontSize: "13px", color: PRIMARY_COLOR, mb: 1 }}>{t('email')}</InputLabel>
                        <Controller
                        name="email"
                        control={control}
                        render={({ field }) => <TextField type="email" {...field} fullWidth/>}
                        {...register("email", { required: "email Address is required" })}
                        />
                        {errors.email?.type === 'required' && <Typography color="error" role="alert" sx={{fontSize:"13px",marginTop:"6px"}}>this field is required</Typography>}
                    </Box>
                    <Box sx={{marginBottom:"30px"}}>
                    <InputLabel sx={{ fontWeight: 700, fontSize: "13px", color: PRIMARY_COLOR, mb: 1 }}>
                {t("password")}
              </InputLabel>
              <Box sx={{ px: {md:0,xs:5}, mb: 2 }}>
                <Box sx={{ direction: "rtl" }}>
                  <ReactCodeInput type="number" fields={4} value={password}
              onChange={(value) => setPassword(value)} />
                </Box>
              </Box>
                        {errors.password?.type === 'required' && <Typography color="error" role="alert" sx={{fontSize:"13px",marginTop:"6px"}}>this field is required</Typography>}
                    </Box>
                    <Button variant='contained' fullWidth type='submit'
                    sx={{textTransform:"capitalize"}}>{t('register')}</Button>
                    </form>
                </Paper>
            </Container>
        </Navbar>
    )
}